import { useDispatch } from "react-redux";
import styled, { css } from "styled-components";

import { toInitialValues as computersFieldtoInitialValues } from "../battle/computerSlice";
import { toInitialValues as playersFieldtoInitialValues } from "../battle/playerSlice";

const StyledButton = styled.button`
    border: none;
    cursor: pointer;
    background-color: #eeeeee;
    width: ${({small}) => small ? '100' : '400'}px;
    height: ${({small}) => small ? '50' : '60'}px;
    border-radius: 10px;
    color: darkslategray;
    font-weight: 700;
    letter-spacing: 3px;

    ${({closeWindow}) => closeWindow && css`
        width: 40px;
        height: 30px;
        position: absolute;
        top: 5px;
        right: 5px;
        color: #8B0000;
    `}

    box-shadow: -7px -7px 20px 0px #fff9,
                -4px -4px 5px 0px #fff9,
                7px 7px 20px 0px #0002,
                4px 4px 5px 0px #0001,
                inset 0px 0px 0px 0px #fff9,
                inset 0px 0px 0px 0px #0001,
                inset 0px 0px 0px 0px #fff9,
                inset 0px 0px 0px 0px #0001;
    transition: box-shadow 0.6s cubic-bezier(.79,.21,.06,.81);

    &:hover {
    box-shadow: 0px 0px 0px 0px #fff9,
                0px 0px 0px 0px #fff9,
                0px 0px 0px 0px #0001,
                0px 0px 0px 0px #0001,
                inset -7px -7px 20px 0px #fff9,
                inset -4px -4px 5px 0px #fff9,
                inset 7px 7px 20px 0px #0003,
                inset 4px 4px 5px 0px #0001;
    }
`;

const Button = ({children, small, closeWindow, setModal}) => {

    const dispatch = useDispatch();

    const cleanFields = () => {
        dispatch(computersFieldtoInitialValues());
        dispatch(playersFieldtoInitialValues());
    }

    const doAction = () => {
        const anchor = children.codePointAt(0) === 9932 ? children.codePointAt(0) : children;
        switch(anchor) {
            case 'Change ships position':
                window.location.reload(false);
                break;
            case 'Start game':
                cleanFields();
                break;
            case 'Let\'s play the game':
                cleanFields();
                break;
            case 'Start a new game':
                setModal(true);
                break;
            case 'Play again':
                cleanFields();
                break;
            case 'Yes':
                cleanFields();
                break;
            case 'No':
                setModal(false);
                break;
            case 9932:
                setModal(false);
                break;
            default: throw new Error(`Wrong case: check buttons text ${children}`);
        }
    }

    return (
        <StyledButton 
            small={small} 
            closeWindow={closeWindow}  
            onClick={doAction}
        >
            {children}
        </StyledButton>
    );
}

export default Button;